<template>
  <div class="ctx-wrap">
    <!-- <transition name="fade-transform" mode="out-in">

    </transition> -->
    <keep-alive :include="pathCacheList">
      <router-view />
    </keep-alive>
    <WaterMark />
  </div>
</template>

<script>
import WaterMark from '../components/WaterMark'
import { mapGetters } from 'vuex'

export default {
  components: {
    WaterMark
  },
  computed: {
    ...mapGetters(['pathCacheList'])
  }
}
</script>

<style lang="less" scoped>
.ctx-wrap {
  flex-grow: 1;
  position: relative;
  overflow-y: auto;
  // width: 1000px;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.25s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(10px);
  position: fixed;
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(10px);
  position: fixed;
}
</style>
